import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'app-carousel-navigation-button',
	standalone: true,
	imports: [],
	templateUrl: './carousel-navigation-button.component.html',
	styleUrl: './carousel-navigation-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselNavigationButtonComponent {
	disabled = input<boolean>(false);
	text = input.required<string>();
}
